import React, { Component } from "react";
import "./Rectangle.css";

export default function Rectangle(props) {
  return (
    <div
      className={props.isOvale ? "ovale" : props.isDiscontinued ? "discRectangle" : "rectangle"}
      style={{
        minWidth: props.rectangleWith,
        maxWidth: props.rectangleWith,
        minHeight: props.rectangleHeight,
        maxHeight: props.rectangleHeight,
        borderColor: props.color,
      }}
    >
      <div style={{
        minWidth: props.rectangleWith,
        maxWidth: props.rectangleWith,
        minHeight: props.rectangleHeight,
        maxHeight: props.rectangleHeight
      }}>{props.title}</div>
    </div>
  );
}
